import { type FC } from 'react';
import { FormattedMessage } from 'dibs-react-intl';
import { Header } from 'dibs-elements/exports/Header.tsx';
import { Button } from 'dibs-elements/exports/Button.tsx';

import styles from './NftMarketNoResults.scss';

export const NftMarketNoResults: FC = () => {
    return (
        <div className={styles.container}>
            <Header
                title={
                    <FormattedMessage
                        id="nft.market.grid.noResults.header"
                        defaultMessage="No NFTs Found"
                    />
                }
            />

            <p className={styles.paragraph}>
                <FormattedMessage
                    id="nft.market.grid.noResults.copy"
                    defaultMessage="Broaden your search by adjusting your filters to get results."
                />
            </p>

            <Button type="secondary" size="medium" href="/nft-collections/featured">
                <FormattedMessage
                    id="nft.market.grid.noResults.viewFeaturedCta"
                    defaultMessage="VIEW FEATURED NFTS"
                />
            </Button>
        </div>
    );
};
